<script setup>

const props = defineProps({
	gridApi: {
		type: Object,
		default: () => ({}),
	},
})

function exportCSV() {
	props.gridApi.exportDataAsCsv()
}

</script>

<template>
	<Button
		@click="exportCSV"
		class="mb-4 text-xs py-1 px-2 self-end"
		color="light-grey"
	>
		Export CSV
	</Button>
</template>

